(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './core-core-stl.js', './kotlin-kotlin-stdlib.js', './core-core-api.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./core-core-stl.js'), require('./kotlin-kotlin-stdlib.js'), require('./core-core-api.js'));
  else {
    if (typeof this['core-core-stl'] === 'undefined') {
      throw new Error("Error loading module 'core-core-experimental'. Its dependency 'core-core-stl' was not found. Please, check whether 'core-core-stl' is loaded prior to 'core-core-experimental'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'core-core-experimental'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'core-core-experimental'.");
    }
    if (typeof this['core-core-api'] === 'undefined') {
      throw new Error("Error loading module 'core-core-experimental'. Its dependency 'core-core-api' was not found. Please, check whether 'core-core-api' is loaded prior to 'core-core-experimental'.");
    }
    root['core-core-experimental'] = factory(typeof this['core-core-experimental'] === 'undefined' ? {} : this['core-core-experimental'], this['core-core-stl'], this['kotlin-kotlin-stdlib'], this['core-core-api']);
  }
}(this, function (_, kotlin_core_core_stl, kotlin_kotlin, kotlin_core_core_api) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var PlacementService = kotlin_core_core_stl.$_$.h2;
  var VOID = kotlin_kotlin.$_$.e;
  var protoOf = kotlin_kotlin.$_$.u9;
  var RestrictAllowedRequiredHostsComponent = kotlin_core_core_api.$_$.w6;
  var Unit_instance = kotlin_kotlin.$_$.x3;
  var Companion_instance = kotlin_core_core_api.$_$.rc;
  var classMeta = kotlin_kotlin.$_$.q8;
  var setMetadataFor = kotlin_kotlin.$_$.v9;
  var get_snapRoot = kotlin_core_core_api.$_$.i1;
  var get_parentComponent = kotlin_core_core_api.$_$.g4;
  var get_connectorsComponent = kotlin_core_core_api.$_$.h2;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.i1;
  var AutoAdaptSessionComponent = kotlin_core_core_stl.$_$.j;
  var get_variantEntities = kotlin_core_core_stl.$_$.t;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.h;
  var SnapUtils_instance = kotlin_core_core_api.$_$.vc;
  var first = kotlin_kotlin.$_$.w5;
  var SnapSettings = kotlin_core_core_api.$_$.a7;
  var toList = kotlin_kotlin.$_$.v7;
  var addAll = kotlin_kotlin.$_$.m4;
  var copyToArray = kotlin_kotlin.$_$.l5;
  var get_worldTransform = kotlin_core_core_api.$_$.n7;
  var TransformUtils_instance = kotlin_core_core_api.$_$.cd;
  var Companion_instance_0 = kotlin_core_core_stl.$_$.e4;
  var get_hierarchy = kotlin_core_core_api.$_$.x3;
  var Companion_instance_1 = kotlin_core_core_stl.$_$.f4;
  var Companion_instance_2 = kotlin_core_core_stl.$_$.d4;
  var Companion_instance_3 = kotlin_core_core_stl.$_$.m4;
  var PlacementResult = kotlin_core_core_stl.$_$.g2;
  var any = kotlin_kotlin.$_$.p4;
  var ValidationResultType_FAIL_getInstance = kotlin_core_core_api.$_$.n8;
  var get_productRefOrEmptyString = kotlin_core_core_api.$_$.x;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.g;
  var Companion_getInstance = kotlin_core_core_api.$_$.tb;
  var firstOrNull = kotlin_kotlin.$_$.u5;
  var equals = kotlin_kotlin.$_$.t8;
  var CollisionValidationResult = kotlin_core_core_api.$_$.z;
  var emptyList = kotlin_kotlin.$_$.o5;
  var SearchDirectionsUtils_instance = kotlin_core_core_stl.$_$.p4;
  var objectMeta = kotlin_kotlin.$_$.t9;
  var Comparator = kotlin_kotlin.$_$.pc;
  var compareValues = kotlin_kotlin.$_$.d8;
  var sortedWith = kotlin_kotlin.$_$.n7;
  var listOf = kotlin_kotlin.$_$.o6;
  var distinct = kotlin_kotlin.$_$.n5;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.v4;
  var plus = kotlin_kotlin.$_$.b7;
  var defineProp = kotlin_kotlin.$_$.s8;
  var interfaceMeta = kotlin_kotlin.$_$.b9;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.j3;
  var Companion_instance_4 = kotlin_core_core_stl.$_$.n4;
  var Vector = kotlin_core_core_api.$_$.c5;
  var Companion_instance_5 = kotlin_core_core_stl.$_$.o4;
  var LoggerState_getInstance = kotlin_core_core_api.$_$.fb;
  var get_worldRotation = kotlin_core_core_api.$_$.m7;
  var Transform = kotlin_core_core_api.$_$.b5;
  var get_worldPosition = kotlin_core_core_api.$_$.l7;
  var recommendedPosition = kotlin_core_core_stl.$_$.l2;
  var ValidationResultType_WARNING_getInstance = kotlin_core_core_api.$_$.o8;
  var toString = kotlin_kotlin.$_$.z9;
  var hashCode = kotlin_kotlin.$_$.a9;
  var THROW_CCE = kotlin_kotlin.$_$.ad;
  //endregion
  //region block: pre-declaration
  setMetadataFor(ExperimentalPlacementService, 'ExperimentalPlacementService', classMeta, PlacementService);
  setMetadataFor(LegacyPlacementHelper, 'LegacyPlacementHelper', classMeta);
  setMetadataFor(Companion, 'Companion', objectMeta);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(SnapList, 'SnapList', classMeta);
  setMetadataFor(SortBuilder, 'SortBuilder', classMeta, VOID, VOID, SortBuilder);
  setMetadataFor(Sorter, 'Sorter', interfaceMeta);
  setMetadataFor(CombinedSorter, 'CombinedSorter', classMeta, VOID, [Sorter]);
  setMetadataFor(SorterByDistance, 'SorterByDistance', classMeta, VOID, [Sorter], SorterByDistance);
  setMetadataFor(OriginalSorter, 'OriginalSorter', classMeta, VOID, [Sorter]);
  setMetadataFor(PrioritySorter, 'PrioritySorter', classMeta, VOID, [Sorter]);
  setMetadataFor(WarningsSorter, 'WarningsSorter', classMeta, VOID, [Sorter], WarningsSorter);
  setMetadataFor(RecommendedDistanceSorter, 'RecommendedDistanceSorter', classMeta, VOID, [Sorter], RecommendedDistanceSorter);
  setMetadataFor(StartPositioner, 'StartPositioner', classMeta);
  setMetadataFor(ValidatedSnap, 'ValidatedSnap', classMeta);
  //endregion
  function ExperimentalPlacementService(coreServices, autoAdaptService) {
    autoAdaptService = autoAdaptService === VOID ? null : autoAdaptService;
    PlacementService.call(this, coreServices, autoAdaptService);
    this.coreServices = coreServices;
    this.autoAdaptService = autoAdaptService;
  }
  protoOf(ExperimentalPlacementService).k2z = function () {
    return this.coreServices;
  };
  protoOf(ExperimentalPlacementService).r3w = function () {
    return this.autoAdaptService;
  };
  protoOf(ExperimentalPlacementService).s3c = function (entityToPlace, initialPosition, ignoreWarnings, searchDirections, sortAndSelectStrategy) {
    var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
    placementHelper.startPoisitoiner(entityToPlace).orAt(initialPosition).move();
    var sortBuilder = placementHelper.sortBuilder();
    var tmp;
    if (ignoreWarnings) {
      tmp = sortBuilder;
    } else {
      tmp = sortBuilder.sortByWarnings();
    }
    var sortBuilderWithWarnings = tmp;
    var sorter = sortBuilderWithWarnings.sortByOriginalFirst(entityToPlace).sortByPriority(true).sortByDistance().build();
    var snaps = placementHelper.findAllSnapsWithAutoAdapt();
    var validatedSnaps = placementHelper.validateSnaps(snaps);
    var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter, searchDirections);
    return placementHelper.commitSnap(snap);
  };
  protoOf(ExperimentalPlacementService).t3c = function (entityToPlace, closeTo, searchDirections, sortAndSelectStrategy) {
    var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
    placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().orAt(closeTo).move();
    var sortBuilder = placementHelper.sortBuilder();
    var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
    var snaps = placementHelper.findAllSnapsWithAutoAdapt();
    var validatedSnaps = placementHelper.validateSnaps(snaps);
    var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter, searchDirections);
    return placementHelper.commitSnap(snap);
  };
  protoOf(ExperimentalPlacementService).u3c = function (entityToPlace, target, sortAndSelectStrategy) {
    var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
    placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().move();
    var sortBuilder = placementHelper.sortBuilder();
    var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [target];
    var snaps = placementHelper.finaAllSnapsToWithAutoAdapt(tmp$ret$2);
    var validatedSnaps = placementHelper.validateSnaps(snaps);
    var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter);
    return placementHelper.commitSnap(snap);
  };
  protoOf(ExperimentalPlacementService).v3c = function (entityToPlace, targets, sortAndSelectStrategy) {
    var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
    placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().move();
    var sortBuilder = placementHelper.sortBuilder();
    var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
    entityToPlace.addComponent(new RestrictAllowedRequiredHostsComponent(targets));
    var snaps = placementHelper.finaAllSnapsToWithAutoAdapt(targets);
    var validatedSnaps = placementHelper.validateSnaps(snaps);
    var snap = placementHelper.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter);
    var result = placementHelper.commitSnap(snap);
    entityToPlace.removeComponent(Companion_instance.id);
    var tmp0_safe_receiver = result.placedEntity;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.removeComponent(Companion_instance.id);
    return result;
  };
  protoOf(ExperimentalPlacementService).x3c = function (entityToPlace, target, sortAndSelectStrategy) {
    var placementHelper = new LegacyPlacementHelper(entityToPlace, this.coreServices);
    placementHelper.startPoisitoiner(entityToPlace).atRecommendedPosition().move();
    var sortBuilder = placementHelper.sortBuilder();
    var sorter = sortBuilder.sortByWarnings().sortByOriginalFirst(entityToPlace).sortByPriority(false).sortByRecommendedDistance().sortByDistance().build();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$2 = [target];
    var snaps = placementHelper.finaAllSnapsToWithAutoAdapt(tmp$ret$2);
    var validatedSnaps = placementHelper.validateSnaps(snaps);
    var snap = placementHelper.firstValid(validatedSnaps, sorter);
    return placementHelper.forceCommitSnap(snap);
  };
  function findSnaps($this, hosts) {
    var tmp3_elvis_lhs = get_snapRoot($this.entity);
    var tmp;
    if (tmp3_elvis_lhs == null) {
      var tmp0_safe_receiver = get_parentComponent($this.entity);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.children;
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.first' call
          var inductionVariable = 0;
          var last = tmp1_safe_receiver.length;
          while (inductionVariable < last) {
            var element = tmp1_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.findSnaps.<anonymous>' call
            if (!(get_connectorsComponent(element) == null)) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          throw NoSuchElementException_init_$Create$('Array contains no element matching the predicate.');
        }
        tmp_0 = tmp$ret$1;
      }
      var tmp2_safe_receiver = tmp_0;
      tmp = tmp2_safe_receiver == null ? null : get_snapRoot(tmp2_safe_receiver);
    } else {
      tmp = tmp3_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp;
    var snappingEntity = tmp4_elvis_lhs == null ? $this.entity : tmp4_elvis_lhs;
    snappingEntity.addComponent(new AutoAdaptSessionComponent());
    moveVariantsToEntityPosition($this, snappingEntity);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_0 = get_variantEntities(snappingEntity);
    var destination = ArrayList_init_$Create$();
    var inductionVariable_0 = 0;
    var last_0 = this_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = this_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.findSnaps.<anonymous>' call
      var tmp_1;
      // Inline function 'kotlin.collections.isNullOrEmpty' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_2;
      if (hosts == null) {
        tmp_2 = true;
      } else {
        // Inline function 'kotlin.collections.isEmpty' call
        tmp_2 = hosts.length === 0;
      }
      if (tmp_2) {
        tmp_1 = SnapUtils_instance.matchingSnapActionCandidatesInScene(element_0, $this.sceneManager, new SnapSettings(true, VOID, VOID, true));
      } else {
        if (hosts.length > 1) {
          tmp_1 = SnapUtils_instance.matchingSnapActionCandidatesMultipleHosts(element_0, hosts, new SnapSettings(true, VOID, VOID, true));
        } else {
          tmp_1 = SnapUtils_instance.matchingSnapActionCandidates(element_0, first(hosts), new SnapSettings(true, VOID, true, true));
        }
      }
      var snapsForGuest = tmp_1;
      var list = toList(snapsForGuest);
      addAll(destination, list);
    }
    var snaps = destination;
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(snaps);
  }
  function moveVariantsToEntityPosition($this, entity) {
    var originalTransform = get_worldTransform(entity);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = get_variantEntities(entity);
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.moveVariantsToEntityPosition.<anonymous>' call
      TransformUtils_instance.setWorldTransform(element, originalTransform);
    }
  }
  function LegacyPlacementHelper(entity, coreServices) {
    this.entity = entity;
    this.coreServices = coreServices;
    this.entityManager = this.coreServices.entityManager;
    this.sceneManager = this.coreServices.sceneManager;
    this.productManager = this.coreServices.productManager;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$0 = [];
    tmp.s3w_1 = new SnapList(this.entity, tmp$ret$0, this.coreServices);
  }
  protoOf(LegacyPlacementHelper).r23 = function () {
    return this.entity;
  };
  protoOf(LegacyPlacementHelper).k2z = function () {
    return this.coreServices;
  };
  protoOf(LegacyPlacementHelper).p1i = function () {
    return this.entityManager;
  };
  protoOf(LegacyPlacementHelper).q1i = function () {
    return this.sceneManager;
  };
  protoOf(LegacyPlacementHelper).u1i = function () {
    return this.productManager;
  };
  protoOf(LegacyPlacementHelper).startPoisitoiner = function (entityToPlace) {
    return new StartPositioner(entityToPlace, this.entityManager);
  };
  protoOf(LegacyPlacementHelper).findAllSnapsWithAutoAdapt = function () {
    var canAutoAdapt = this.entity.hasComponent(126);
    var tmp;
    if (canAutoAdapt) {
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_0 = get_hierarchy(this.sceneManager.root);
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.findAllSnapsWithAutoAdapt.<anonymous>' call
        if (element.hasComponent(127)) {
          destination.q(element);
        }
      }
      tmp = destination;
    } else {
      tmp = null;
    }
    var hosts = tmp;
    var tmp_0;
    if (hosts == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(hosts);
    }
    return findSnaps(this, tmp_0);
  };
  protoOf(LegacyPlacementHelper).finaAllSnapsToWithAutoAdapt = function (targets) {
    return findSnaps(this, targets);
  };
  protoOf(LegacyPlacementHelper).commitSnap = function (validatedSnap) {
    var tmp;
    if ((validatedSnap == null ? null : validatedSnap.isValid) === true) {
      tmp = validatedSnap.snap;
    } else {
      tmp = null;
    }
    var snapActionCandidate = tmp;
    var tmp2_elvis_lhs = validatedSnap == null ? null : validatedSnap.result;
    var tmp_0;
    if (tmp2_elvis_lhs == null) {
      // Inline function 'kotlin.emptyArray' call
      tmp_0 = [];
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    var results = tmp_0;
    if (snapActionCandidate == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      snapActionCandidate.createAction().perform();
      var tmp_1 = snapActionCandidate.guestRoot;
      tmp_1.removeComponent(125);
      var tmp_2;
      if (any(results)) {
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$1 = [];
        tmp_2 = new PlacementResult(results, tmp$ret$1, snapActionCandidate.guestRoot);
      } else {
        tmp_2 = Companion_instance_3.ok(snapActionCandidate.guestRoot);
      }
      return tmp_2;
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var inductionVariable = 0;
    var last = results.length;
    while (inductionVariable < last) {
      var element = results[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.commitSnap.<anonymous>' call
      if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
        destination.q(element);
      }
    }
    var errors = copyToArray(destination);
    this.entity.removeComponent(125);
    var tmp_3;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(errors.length === 0)) {
      tmp_3 = Companion_instance_3.failWithErrors(errors);
    } else {
      tmp_3 = Companion_instance_3.failWithMessage('No snap found', get_productRefOrEmptyString(this.entity));
    }
    return tmp_3;
  };
  protoOf(LegacyPlacementHelper).forceCommitSnap = function (validatedSnap) {
    var tmp1_safe_receiver = validatedSnap == null ? null : validatedSnap.snap;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      tmp1_safe_receiver.createAction().perform();
      return Companion_instance_3.ok(this.entity);
    }
    return Companion_instance_3.failWithMessage('No possible snapActions in target', get_productRefOrEmptyString(this.entity));
  };
  protoOf(LegacyPlacementHelper).sortBuilder = function () {
    return new SortBuilder();
  };
  protoOf(LegacyPlacementHelper).validateSnaps = function (snaps) {
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(snaps.length);
    var inductionVariable = 0;
    var last = snaps.length;
    while (inductionVariable < last) {
      var item = snaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.LegacyPlacementHelper.validateSnaps.<anonymous>' call
      var result = this.coreServices.validations.validateSnap(item);
      var tmp$ret$0 = new ValidatedSnap(item, result);
      destination.q(tmp$ret$0);
    }
    return copyToArray(destination);
  };
  protoOf(LegacyPlacementHelper).t3w = function (validatedSnaps, sorter, searchDirections) {
    return this.s3w_1.firstValidWhenExtendingSearchOnContinuousConnectors(validatedSnaps, sorter, searchDirections);
  };
  protoOf(LegacyPlacementHelper).firstValidWhenExtendingSearchOnContinuousConnectors = function (validatedSnaps, sorter, searchDirections, $super) {
    var tmp;
    if (searchDirections === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [Companion_getInstance().LEFT, Companion_getInstance().RIGHT, Companion_getInstance().UP, Companion_getInstance().DOWN, Companion_getInstance().BACK, Companion_getInstance().FORWARD];
    } else {
      tmp = searchDirections;
    }
    searchDirections = tmp;
    return this.t3w(validatedSnaps, sorter, searchDirections);
  };
  protoOf(LegacyPlacementHelper).firstValid = function (validatedSnaps, sorter) {
    return this.s3w_1.firstValid(validatedSnaps, sorter);
  };
  function best($this, candidate, bestSoFar, sorter) {
    if (!candidate.isValid)
      return bestSoFar;
    if (bestSoFar == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return sorter.aaa(bestSoFar, candidate);
    }
    return candidate;
  }
  function validate($this, candidate, validationService) {
    var candidateResult = new ValidatedSnap(candidate, validationService.validateSnap(candidate));
    return candidateResult;
  }
  function getAlignmentCandidatesThatResolvesCollision($this, candidates, failedCandidateResult) {
    var tmp0_safe_receiver = failedCandidateResult.result;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.getAlignmentCandidatesThatResolvesCollision.<anonymous>' call
        if (element instanceof CollisionValidationResult) {
          var tmp0_safe_receiver_0 = firstOrNull(element.collisions);
          var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.other;
          if (tmp1_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList_init_$Create$();
            var tmp0_iterator = candidates.t();
            while (tmp0_iterator.u()) {
              var element_0 = tmp0_iterator.w();
              // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.getAlignmentCandidatesThatResolvesCollision.<anonymous>.<anonymous>.<anonymous>' call
              var tmp;
              var tmp0_safe_receiver_1 = element_0.snap.alignmentInitiatorCandidate;
              if (equals(tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.host, tmp1_safe_receiver)) {
                tmp = element_0.isValid;
              } else {
                tmp = false;
              }
              if (tmp) {
                destination.q(element_0);
              }
            }
            return destination;
          }
        }
      }
    }
    return emptyList();
  }
  function findNewPositionThatMightSatisfyFailedResult($this, failed, entityToAdd, searchDirections, level) {
    var tmp0_safe_receiver = failed.result;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findNewPositionThatMightSatisfyFailedResult.<anonymous>' call
        var tmp_0;
        if (element instanceof CollisionValidationResult) {
          tmp_0 = SearchDirectionsUtils_instance.findNewPositionOnSidesOfCollidingEntity(entityToAdd, failed.snap, element, searchDirections, level === 0);
        } else {
          tmp_0 = emptyList();
        }
        var list = tmp_0;
        addAll(destination, list);
      }
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
  }
  function Companion() {
    this.MAX_SEARCH_LVL_SNAP_TO_SCENE = 5;
  }
  protoOf(Companion).r3d = function () {
    return this.MAX_SEARCH_LVL_SNAP_TO_SCENE;
  };
  var Companion_instance_6;
  function Companion_getInstance_0() {
    return Companion_instance_6;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.u3w_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).u1j = function (a, b) {
    return this.u3w_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.u1j(a, b);
  };
  function SnapList$sortByDistance$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.sortByDistance.<anonymous>' call
    var tmp = a.snap.movement.size;
    // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.sortByDistance.<anonymous>' call
    var tmp$ret$1 = b.snap.movement.size;
    return compareValues(tmp, tmp$ret$1);
  }
  function SnapList(entity, snaps, coreServices) {
    this.entity = entity;
    this.snaps = snaps;
    this.coreServices = coreServices;
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.snaps;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$_0(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.validatedSnaps.<anonymous>' call
      var tmp$ret$0 = new ValidatedSnap(item, null);
      destination.q(tmp$ret$0);
    }
    tmp.validatedSnaps = copyToArray(destination);
    this.validataionService = this.coreServices.validations;
  }
  protoOf(SnapList).r23 = function () {
    return this.entity;
  };
  protoOf(SnapList).v3w = function () {
    return this.snaps;
  };
  protoOf(SnapList).k2z = function () {
    return this.coreServices;
  };
  protoOf(SnapList).w3w = function (_set____db54di) {
    this.validatedSnaps = _set____db54di;
  };
  protoOf(SnapList).x3w = function () {
    return this.validatedSnaps;
  };
  protoOf(SnapList).y3w = function () {
    return this.validataionService;
  };
  protoOf(SnapList).sortByDistance = function () {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = this.validatedSnaps;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = SnapList$sortByDistance$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_0);
    var this_1 = sortedWith(this_0, tmp$ret$0);
    tmp.validatedSnaps = copyToArray(this_1);
  };
  protoOf(SnapList).validateAll = function () {
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.validatedSnaps;
    var destination = ArrayList_init_$Create$();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.validateAll.<anonymous>' call
      var snap = element.af();
      var result = this.coreServices.validations.validateSnap(snap);
      var tmp0_safe_receiver = new ValidatedSnap(snap, result);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.q(tmp0_safe_receiver);
      }
    }
    tmp.validatedSnaps = copyToArray(destination);
  };
  protoOf(SnapList).firstValid = function (validatedSnaps, sorter) {
    var bestSoFar = null;
    var inductionVariable = 0;
    var last = validatedSnaps.length;
    while (inductionVariable < last) {
      var cr = validatedSnaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cr.isValid) {
        bestSoFar = best(this, cr, bestSoFar, sorter);
      }
    }
    var tmp;
    if (!(bestSoFar == null)) {
      tmp = bestSoFar;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = validatedSnaps.length;
      while (inductionVariable_0 < last_0) {
        var element = validatedSnaps[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.firstValid.<anonymous>' call
        var tmp0_safe_receiver = element.result;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toList(tmp0_safe_receiver);
        var list = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
        addAll(destination, list);
      }
      var allResults = copyToArray(destination);
      var tmp1_safe_receiver = firstOrNull(validatedSnaps);
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.copy(VOID, allResults);
    }
    return tmp;
  };
  protoOf(SnapList).t3w = function (validatedSnaps, sorter, searchDirections) {
    var bestSoFar = null;
    var inductionVariable = 0;
    var last = validatedSnaps.length;
    while (inductionVariable < last) {
      var cr = validatedSnaps[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (cr.isValid) {
        bestSoFar = best(this, cr, bestSoFar, sorter);
      } else if (cr.snap.hostConnector.isContinuousConnector ? cr.snap.alignmentInitiatorCandidate == null : false) {
        bestSoFar = this.findBestValidPositionOnConnector(toList(validatedSnaps), bestSoFar, listOf(cr), this.entity, cr.snap, searchDirections, this.validataionService, sorter);
      }
    }
    var tmp;
    if (!(bestSoFar == null)) {
      tmp = bestSoFar;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList_init_$Create$();
      var inductionVariable_0 = 0;
      var last_0 = validatedSnaps.length;
      while (inductionVariable_0 < last_0) {
        var element = validatedSnaps[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.firstValidWhenExtendingSearchOnContinuousConnectors.<anonymous>' call
        var tmp0_safe_receiver = element.result;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toList(tmp0_safe_receiver);
        var list = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
        addAll(destination, list);
      }
      var allResults = copyToArray(destination);
      var tmp1_safe_receiver = firstOrNull(validatedSnaps);
      tmp = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.copy(VOID, allResults);
    }
    return tmp;
  };
  protoOf(SnapList).firstValidWhenExtendingSearchOnContinuousConnectors = function (validatedSnaps, sorter, searchDirections, $super) {
    var tmp;
    if (searchDirections === VOID) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [Companion_getInstance().LEFT, Companion_getInstance().RIGHT, Companion_getInstance().UP, Companion_getInstance().DOWN, Companion_getInstance().BACK, Companion_getInstance().FORWARD];
    } else {
      tmp = searchDirections;
    }
    searchDirections = tmp;
    return this.t3w(validatedSnaps, sorter, searchDirections);
  };
  protoOf(SnapList).z3w = function (validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level) {
    if (level >= 5) {
      return bestSoFar;
    }
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator = failed.t();
    while (tmp0_iterator.u()) {
      var element = tmp0_iterator.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      var list = getAlignmentCandidatesThatResolvesCollision(this, validatedCandidates, element);
      addAll(destination, list);
    }
    var validAlignments = destination;
    var localBest = null;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = validAlignments.t();
    while (tmp0_iterator_0.u()) {
      var element_0 = tmp0_iterator_0.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      localBest = best(this, element_0, localBest, sorter);
    }
    var tmp0_safe_receiver = localBest;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return best(this, tmp0_safe_receiver, bestSoFar, sorter);
    }
    var initialTransform = get_worldTransform(entityToAdd);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterNot' call
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination_0 = ArrayList_init_$Create$();
    var tmp0_iterator_1 = failed.t();
    while (tmp0_iterator_1.u()) {
      var element_1 = tmp0_iterator_1.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      var list_0 = findNewPositionThatMightSatisfyFailedResult(this, element_1, entityToAdd, searchDirections, level);
      addAll(destination_0, list_0);
    }
    // Inline function 'kotlin.collections.filterNotTo' call
    var this_0 = distinct(destination_0);
    var destination_1 = ArrayList_init_$Create$();
    var tmp0_iterator_2 = this_0.t();
    while (tmp0_iterator_2.u()) {
      var element_2 = tmp0_iterator_2.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      if (!triedPositions.p(element_2)) {
        destination_1.q(element_2);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$();
    var tmp0_iterator_3 = destination_1.t();
    while (tmp0_iterator_3.u()) {
      var element_3 = tmp0_iterator_3.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      if (bestSoFar == null ? true : initialTransform.position.distanceTo(element_3) < bestSoFar.snap.movement.size) {
        destination_2.q(element_3);
      }
    }
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$();
    var tmp0_iterator_4 = destination_2.t();
    while (tmp0_iterator_4.u()) {
      var element_4 = tmp0_iterator_4.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      if (SnapUtils_instance.isNewPositionOnHostConnector(candidate, element_4)) {
        destination_3.q(element_4);
      }
    }
    var newPositions = destination_3;
    if (newPositions.b1() ? !(bestSoFar == null) : false) {
      return bestSoFar;
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$_0(collectionSizeOrDefault(newPositions, 10));
    var tmp0_iterator_5 = newPositions.t();
    while (tmp0_iterator_5.u()) {
      var item = tmp0_iterator_5.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      var newCandidate = SnapUtils_instance.createCandidate(candidate.guest, candidate.guestConnector, candidate.host, candidate.hostConnector, candidate.endTransform.copy(item), VOID, VOID, initialTransform);
      var tmp$ret$16 = validate(this, newCandidate, validationService);
      destination_4.q(tmp$ret$16);
    }
    var newResults = destination_4;
    localBest = null;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_5 = ArrayList_init_$Create$();
    var tmp0_iterator_6 = newResults.t();
    while (tmp0_iterator_6.u()) {
      var element_5 = tmp0_iterator_6.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      if (element_5.isValid) {
        destination_5.q(element_5);
      }
    }
    var tmp0_iterator_7 = destination_5.t();
    while (tmp0_iterator_7.u()) {
      var element_6 = tmp0_iterator_7.w();
      // Inline function 'com.ikea.core.experimental.placement.twopointo.SnapList.findBestValidPositionOnConnector.<anonymous>' call
      localBest = best(this, element_6, localBest, sorter);
    }
    var tmp1_safe_receiver = localBest;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      return best(this, tmp1_safe_receiver, bestSoFar, sorter);
    }
    return this.findBestValidPositionOnConnector(validatedCandidates, bestSoFar, newResults, entityToAdd, candidate, searchDirections, validationService, sorter, plus(triedPositions, newPositions), level + 1 | 0);
  };
  protoOf(SnapList).findBestValidPositionOnConnector = function (validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level, $super) {
    triedPositions = triedPositions === VOID ? emptyList() : triedPositions;
    level = level === VOID ? 0 : level;
    return this.z3w(validatedCandidates, bestSoFar, failed, entityToAdd, candidate, searchDirections, validationService, sorter, triedPositions, level);
  };
  function get_logger() {
    _init_properties_SortBuilder_kt__dwrk6j();
    return logger;
  }
  var logger;
  function SortBuilder() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.a3x_1 = ArrayList_init_$Create$();
  }
  protoOf(SortBuilder).sortByDistance = function () {
    this.a3x_1.q(new SorterByDistance());
    return this;
  };
  protoOf(SortBuilder).build = function () {
    return new CombinedSorter(this.a3x_1);
  };
  protoOf(SortBuilder).sortByOriginalFirst = function (entityToPlace) {
    this.a3x_1.q(new OriginalSorter(entityToPlace));
    return this;
  };
  protoOf(SortBuilder).sortByPriority = function (onlyInActivationDistance) {
    this.a3x_1.q(new PrioritySorter(onlyInActivationDistance));
    return this;
  };
  protoOf(SortBuilder).sortByRecommendedDistance = function () {
    this.a3x_1.q(new RecommendedDistanceSorter());
    return this;
  };
  protoOf(SortBuilder).sortByWarnings = function () {
    this.a3x_1.q(new WarningsSorter());
    return this;
  };
  function Sorter() {
  }
  function CombinedSorter(sorters) {
    this.sorters = sorters;
  }
  protoOf(CombinedSorter).b3x = function () {
    return this.sorters;
  };
  protoOf(CombinedSorter).aaa = function (a, b) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
      var tmp0_iterator = this.sorters.t();
      while (tmp0_iterator.u()) {
        var element = tmp0_iterator.w();
        // Inline function 'com.ikea.core.experimental.placement.twopointo.CombinedSorter.sort.<anonymous>' call
        var result = element.aaa(a, b);
        if (!(result == null)) {
          tmp$ret$1 = result;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    var best = tmp$ret$1;
    return best == null ? a : best;
  };
  function SorterByDistance() {
  }
  protoOf(SorterByDistance).aaa = function (a, b) {
    var tmp;
    if (a.snap.movement.size < b.snap.movement.size) {
      tmp = a;
    } else if (a.snap.movement.size > b.snap.movement.size) {
      tmp = b;
    } else {
      tmp = null;
    }
    return tmp;
  };
  function OriginalSorter(originalEntity) {
    this.c3x_1 = originalEntity;
  }
  protoOf(OriginalSorter).aaa = function (a, b) {
    var aIsOriginal = a.snap.guestRoot.equals(this.c3x_1);
    var bIsOriginal = b.snap.guestRoot.equals(this.c3x_1);
    var tmp;
    if (aIsOriginal ? bIsOriginal : false) {
      tmp = null;
    } else if (aIsOriginal) {
      tmp = a;
    } else {
      tmp = b;
    }
    return tmp;
  };
  function PrioritySorter(onlyInActivationDistance) {
    this.onlyInActivationDistance = onlyInActivationDistance;
  }
  protoOf(PrioritySorter).y3d = function () {
    return this.onlyInActivationDistance;
  };
  protoOf(PrioritySorter).aaa = function (a, b) {
    var tmp;
    if (a.snap.inActivationDistance() ? true : !this.onlyInActivationDistance) {
      tmp = a.snap.priority;
    } else {
      tmp = IntCompanionObject_instance.MIN_VALUE;
    }
    var aPrio = tmp;
    var tmp_0;
    if (b.snap.inActivationDistance() ? true : !this.onlyInActivationDistance) {
      tmp_0 = b.snap.priority;
    } else {
      tmp_0 = IntCompanionObject_instance.MIN_VALUE;
    }
    var bPrio = tmp_0;
    var tmp_1;
    if (aPrio > bPrio) {
      tmp_1 = a;
    } else if (aPrio < bPrio) {
      tmp_1 = b;
    } else {
      tmp_1 = null;
    }
    return tmp_1;
  };
  function WarningsSorter() {
  }
  protoOf(WarningsSorter).aaa = function (a, b) {
    var aWarnings = a.countWarnings();
    var bWarnings = b.countWarnings();
    var tmp;
    if (aWarnings > bWarnings) {
      tmp = b;
    } else if (aWarnings < bWarnings) {
      tmp = a;
    } else {
      tmp = null;
    }
    return tmp;
  };
  function recommendationDistance($this, candidate) {
    var result = Companion_getInstance().ZERO;
    var tmp = candidate.guestRoot;
    var tmp0_safe_receiver = tmp.__getComponentForKotlin(59);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = tmp0_safe_receiver.offsetY - candidate.endTransform.position.Y;
      var diff = Math.abs(this_0);
      result = new Vector(0.0, diff, 0.0);
    }
    var tmp_0 = candidate.guestRoot;
    if (tmp_0.__getComponentForKotlin(60) == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp_1 = get_logger();
      tmp_1.warn(RecommendedDistanceSorter$recommendationDistance$lambda);
    }
    return result;
  }
  function RecommendedDistanceSorter$recommendationDistance$lambda() {
    return 'PositionFromParent is not yet implemented';
  }
  function RecommendedDistanceSorter() {
  }
  protoOf(RecommendedDistanceSorter).aaa = function (a, b) {
    var aDist = recommendationDistance(this, a.snap).size;
    var bDist = recommendationDistance(this, b.snap).size;
    var tmp;
    if (aDist < bDist) {
      tmp = a;
    } else if (aDist > bDist) {
      tmp = b;
    } else {
      tmp = null;
    }
    return tmp;
  };
  var properties_initialized_SortBuilder_kt_lj95wt;
  function _init_properties_SortBuilder_kt__dwrk6j() {
    if (!properties_initialized_SortBuilder_kt_lj95wt) {
      properties_initialized_SortBuilder_kt_lj95wt = true;
      logger = LoggerState_getInstance().m1m('RecommendedDistanceSorter');
    }
  }
  function StartPositioner(entity, entityManager) {
    this.entity = entity;
    this.entityManager = entityManager;
    this.d3x_1 = false;
  }
  protoOf(StartPositioner).r23 = function () {
    return this.entity;
  };
  protoOf(StartPositioner).p1i = function () {
    return this.entityManager;
  };
  protoOf(StartPositioner).at = function (vector) {
    if (vector == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      TransformUtils_instance.setWorldTransform(this.entity, new Transform(vector, get_worldRotation(this.entity)));
      this.d3x_1 = true;
    }
    return this;
  };
  protoOf(StartPositioner).atRecommendedPosition = function () {
    var tmp0_safe_receiver = recommendedPosition(this.entity, get_worldPosition(this.entity));
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      TransformUtils_instance.setWorldTransform(this.entity, new Transform(tmp0_safe_receiver, get_worldRotation(this.entity)));
      this.d3x_1 = true;
    }
    return this;
  };
  protoOf(StartPositioner).orAtRecommendedPosition = function () {
    if (!this.d3x_1) {
      this.atRecommendedPosition();
    }
    return this;
  };
  protoOf(StartPositioner).orAt = function (vector) {
    if (!this.d3x_1) {
      if (vector == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'com.ikea.core.experimental.placement.twopointo.StartPositioner.orAt.<anonymous>' call
        this.at(vector);
      }
    }
    return this;
  };
  protoOf(StartPositioner).move = function () {
  };
  function ValidatedSnap(snap, result) {
    result = result === VOID ? null : result;
    this.snap = snap;
    this.result = result;
    var tmp = this;
    var tmp0_safe_receiver = this.result;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp$ret$1;
      $l$block: {
        // Inline function 'kotlin.collections.none' call
        var inductionVariable = 0;
        var last = tmp0_safe_receiver.length;
        while (inductionVariable < last) {
          var element = tmp0_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'com.ikea.core.experimental.placement.twopointo.ValidatedSnap.isValid.<anonymous>' call
          if (element.resultType.equals(ValidationResultType_FAIL_getInstance())) {
            tmp$ret$1 = false;
            break $l$block;
          }
        }
        tmp$ret$1 = true;
      }
      tmp_0 = tmp$ret$1;
    }
    var tmp1_elvis_lhs = tmp_0;
    tmp.isValid = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  protoOf(ValidatedSnap).s1m = function () {
    return this.snap;
  };
  protoOf(ValidatedSnap).e3x = function (_set____db54di) {
    this.result = _set____db54di;
  };
  protoOf(ValidatedSnap).f3x = function () {
    return this.result;
  };
  protoOf(ValidatedSnap).g3x = function () {
    return this.isValid;
  };
  protoOf(ValidatedSnap).h3x = function () {
    return !(this.result == null);
  };
  protoOf(ValidatedSnap).countWarnings = function () {
    var tmp0_safe_receiver = this.result;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.count' call
      var count = 0;
      var inductionVariable = 0;
      var last = tmp0_safe_receiver.length;
      while (inductionVariable < last) {
        var element = tmp0_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'com.ikea.core.experimental.placement.twopointo.ValidatedSnap.countWarnings.<anonymous>' call
        if (element.resultType.equals(ValidationResultType_WARNING_getInstance())) {
          count = count + 1 | 0;
        }
      }
      tmp = count;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ValidatedSnap).af = function () {
    return this.snap;
  };
  protoOf(ValidatedSnap).bf = function () {
    return this.result;
  };
  protoOf(ValidatedSnap).i3x = function (snap, result) {
    return new ValidatedSnap(snap, result);
  };
  protoOf(ValidatedSnap).copy = function (snap, result, $super) {
    snap = snap === VOID ? this.snap : snap;
    result = result === VOID ? this.result : result;
    return this.i3x(snap, result);
  };
  protoOf(ValidatedSnap).toString = function () {
    return 'ValidatedSnap(snap=' + this.snap + ', result=' + toString(this.result) + ')';
  };
  protoOf(ValidatedSnap).hashCode = function () {
    var result = hashCode(this.snap);
    result = imul(result, 31) + (this.result == null ? 0 : hashCode(this.result)) | 0;
    return result;
  };
  protoOf(ValidatedSnap).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ValidatedSnap))
      return false;
    var tmp0_other_with_cast = other instanceof ValidatedSnap ? other : THROW_CCE();
    if (!equals(this.snap, tmp0_other_with_cast.snap))
      return false;
    if (!equals(this.result, tmp0_other_with_cast.result))
      return false;
    return true;
  };
  //region block: post-declaration
  defineProp(protoOf(ValidatedSnap), 'isValidated', protoOf(ValidatedSnap).h3x);
  //endregion
  //region block: init
  Companion_instance_6 = new Companion();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$experimental = $com$ikea$core.experimental || ($com$ikea$core.experimental = {});
    var $com$ikea$core$experimental$placement = $com$ikea$core$experimental.placement || ($com$ikea$core$experimental.placement = {});
    $com$ikea$core$experimental$placement.ExperimentalPlacementService = ExperimentalPlacementService;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$experimental = $com$ikea$core.experimental || ($com$ikea$core.experimental = {});
    var $com$ikea$core$experimental$placement = $com$ikea$core$experimental.placement || ($com$ikea$core$experimental.placement = {});
    var $com$ikea$core$experimental$placement$twopointo = $com$ikea$core$experimental$placement.twopointo || ($com$ikea$core$experimental$placement.twopointo = {});
    $com$ikea$core$experimental$placement$twopointo.LegacyPlacementHelper = LegacyPlacementHelper;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$experimental = $com$ikea$core.experimental || ($com$ikea$core.experimental = {});
    var $com$ikea$core$experimental$placement = $com$ikea$core$experimental.placement || ($com$ikea$core$experimental.placement = {});
    var $com$ikea$core$experimental$placement$twopointo = $com$ikea$core$experimental$placement.twopointo || ($com$ikea$core$experimental$placement.twopointo = {});
    $com$ikea$core$experimental$placement$twopointo.SnapList = SnapList;
    defineProp($com$ikea$core$experimental$placement$twopointo.SnapList, 'Companion', Companion_getInstance_0);
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$experimental = $com$ikea$core.experimental || ($com$ikea$core.experimental = {});
    var $com$ikea$core$experimental$placement = $com$ikea$core$experimental.placement || ($com$ikea$core$experimental.placement = {});
    var $com$ikea$core$experimental$placement$twopointo = $com$ikea$core$experimental$placement.twopointo || ($com$ikea$core$experimental$placement.twopointo = {});
    $com$ikea$core$experimental$placement$twopointo.SortBuilder = SortBuilder;
    $com$ikea$core$experimental$placement$twopointo.CombinedSorter = CombinedSorter;
    $com$ikea$core$experimental$placement$twopointo.SorterByDistance = SorterByDistance;
    $com$ikea$core$experimental$placement$twopointo.OriginalSorter = OriginalSorter;
    $com$ikea$core$experimental$placement$twopointo.PrioritySorter = PrioritySorter;
    $com$ikea$core$experimental$placement$twopointo.WarningsSorter = WarningsSorter;
    $com$ikea$core$experimental$placement$twopointo.RecommendedDistanceSorter = RecommendedDistanceSorter;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$experimental = $com$ikea$core.experimental || ($com$ikea$core.experimental = {});
    var $com$ikea$core$experimental$placement = $com$ikea$core$experimental.placement || ($com$ikea$core$experimental.placement = {});
    var $com$ikea$core$experimental$placement$twopointo = $com$ikea$core$experimental$placement.twopointo || ($com$ikea$core$experimental$placement.twopointo = {});
    $com$ikea$core$experimental$placement$twopointo.StartPositioner = StartPositioner;
    var $com = _.com || (_.com = {});
    var $com$ikea = $com.ikea || ($com.ikea = {});
    var $com$ikea$core = $com$ikea.core || ($com$ikea.core = {});
    var $com$ikea$core$experimental = $com$ikea$core.experimental || ($com$ikea$core.experimental = {});
    var $com$ikea$core$experimental$placement = $com$ikea$core$experimental.placement || ($com$ikea$core$experimental.placement = {});
    var $com$ikea$core$experimental$placement$twopointo = $com$ikea$core$experimental$placement.twopointo || ($com$ikea$core$experimental$placement.twopointo = {});
    $com$ikea$core$experimental$placement$twopointo.ValidatedSnap = ValidatedSnap;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = LegacyPlacementHelper;
  _.$_$.b = ValidatedSnap;
  _.$_$.c = ExperimentalPlacementService;
  //endregion
  return _;
}));

//# sourceMappingURL=core-core-experimental.js.map
